import {PatchConfirmAddressV4Params} from 'domain/usecases';
import {makePatchConfirmAddressV4} from 'main/factories/usecases';

type PatchConfirmAddressParams = Omit<PatchConfirmAddressV4Params, 'signal'> & {
	signal?: AbortSignal;
};

export async function patchConfirmAddress(params: PatchConfirmAddressParams): Promise<void> {
	return makePatchConfirmAddressV4(params.sequence).patch(params);
}
